import React, { Component } from 'react';
import Constants from '../../Config/Config';

class FramedSize extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const target = e.target;
    const name = target.name;
    let value = target.value;
 
    let frameImageHeightVal = value;
    let frameImageWidthVal = value;

    if (this.props.frameImage !== null) {
      if (name === 'frameImageWidth') {
        frameImageHeightVal = (frameImageHeightVal / this.props.aspectRatio).toFixed(1);
      }
      if (name === 'frameImageHeight') {
        frameImageWidthVal = (frameImageWidthVal * this.props.aspectRatio).toFixed(1);
      }
      this.props.dispatch({
        type: 'SET_STATE',
        state: {
          frameImageHeight: frameImageHeightVal,
          frameImageWidth: frameImageWidthVal
        }
      })
    } else {
      if (name === 'frameImageHeight') {
        this.props.dispatch({
          type: 'SET_STATE',
          state: {
            frameImageHeight: frameImageHeightVal
          }
        })
      }
      if (name === 'frameImageWidth') {
        this.props.dispatch({
          type: 'SET_STATE',
          state: {
            frameImageWidth: frameImageWidthVal
          }
        })
      }
    }
  }

  render() {
    const {frameImageHeight, frameImageWidth} = this.props;
    return (
      <div className="top_cont">
        <ul> 
          <li className="frame-size-li"><p>Image Size:</p></li>
          <li>
            <label>Width</label>
            <div className="quantity">
              <input step=".1" type="number" min="20" max="125" id="frameImageWidth" name="frameImageWidth" value={frameImageWidth} onChange={this.handleChange} className={parseFloat(frameImageWidth) < 20 || parseFloat(frameImageWidth) > 125 ? "image-size-error" : ""} />
            </div>
          </li>
          <li>
            <label>Height</label>
            <div className="quantity">
              <input type="number" step=".1" min="20" max="125" id="frameImageHeight" name="frameImageHeight" value={frameImageHeight} onChange={this.handleChange} className={parseFloat(frameImageHeight) < 20 || parseFloat(frameImageHeight) > 125 ? "image-size-error" : ""} />
            </div>
          </li>
        </ul>
        <p>Min: {Constants.MIN_IMAGE_DIMENSIONS_CM} cm, Max: {Constants.MAX_IMAGE_DIMENSIONS_CM} cm</p>
      </div>
    );
  }
}
export default FramedSize;